(function ($) {
  $(document).ready(function () {
    $(".slideshow").slick({
      autoplay: true,
      autoplaySpeed: 4500,
      speed: 1500,
      infinite: true,
      mobileFirst: true,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      slidesToShow: 1,
      fade: true,
    });
  });
})(jQuery);
